import config from 'app/config';
import mrscta from './cta/cta.component';
import mrsfooter from './footer/footer.component';
import mrsvideo from '@common/components/video/video.component';
// import mrsmodal from './modal/modal.component'; //reinit if needed
import countdown from '@common/components/countdown/countdown.component';
import opform from '@common/components/opform/opform.component';
// import hsform from './hsform/hsform.component';

const components = [
  mrscta,
  mrsfooter,
  mrsvideo,
  // mrsmodal,
  countdown,
  opform,
];

export default angular
  .module(`${config.appName}.commonComponents`, components)
  .name;